/*
* @Author: MaYanXia
* @Date:   2020-06-04 17:02:45
 * @Last Modified by: mayanxia
 * @Last Modified time: 2021-01-18 20:37:18
*/
import Vue from 'vue'
export const screenFullMixin = {
    methods: {
        screenFull() {
            var body = document.querySelector("body");
            if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
                  if (document.cancelFullscreen) {
                      document.cancelFullscreen();
                  } else if (document.webkitCancelFullScreen) {
                      document.webkitCancelFullScreen();
                  } else if (document.mozCancelFullScreen) {
                      document.mozCancelFullScreen();
                  } else if (document.msCancelFullScreen) {
                      document.msCancelFullScreen();
                  }
              } else {
                if (body.requestFullscreen) {
                  body.requestFullscreen();
                  } else if (body.webkitRequestFullScreen) {
                    body.webkitRequestFullScreen();
                  } else if (body.mozRequestFullScreen) {
                    body.mozRequestFullScreen();
                  } else if (body.msRequestFullScreen) {
                    body.msRequestFullScreen();
                  }
              
            }
        }
    }
}